import TimeInput from '@/components/time-input/time-input.view';
import { Box, ButtonGroup, Grid, IconButton, Menu, MenuButton, MenuItem, MenuList, Tooltip } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { BiDotsVerticalRounded } from 'react-icons/bi';
import { FiCopy, FiPlus, FiTrash } from 'react-icons/fi';

interface IProps {
	isLoading?: boolean;
	value: { start: string; end: string };
	onChange: (value: { start: string; end: string }) => void;
	onAddClick: () => void;
	onDeleteClick: () => void;
	onRepeatClick: () => void;
	shouldDisplayRepeat: boolean;
	shouldDisplayAdd: boolean;
}

export function ScheduleInterval(props: IProps) {
	const { t } = useTranslation();

	function handleStartChange(start: string) {
		props.onChange({ ...props.value, start });
	}

	function handleEndChange(end: string) {
		props.onChange({ ...props.value, end });
	}

	return (
		<Box display="grid" gridTemplateColumns="auto auto">
			<Grid gridTemplateColumns="70px 70px" gap={0.5}>
				<TimeInput isDisabled={props.isLoading} onChange={handleStartChange} value={props.value.start} size="sm" />
				<TimeInput isDisabled={props.isLoading} onChange={handleEndChange} value={props.value.end} size="sm" />
			</Grid>

			<Box display={{ base: 'initial', md: 'none' }}>
				<Menu>
					<MenuButton
						variant="ghost"
						size="sm"
						as={IconButton}
						icon={<BiDotsVerticalRounded />}
						aria-label={t('Menu')}
					/>
					<MenuList>
						<MenuItem onClick={props.onDeleteClick}>{t('Delete interval')}</MenuItem>
						{props.shouldDisplayRepeat ? (
							<MenuItem onClick={props.onRepeatClick}>{t('Repeat every weekday')}</MenuItem>
						) : null}
						{props.shouldDisplayAdd ? <MenuItem onCanPlay={props.onAddClick}>{t('Add interval')}</MenuItem> : null}
					</MenuList>
				</Menu>
			</Box>

			<ButtonGroup
				isAttached
				variant="ghost"
				ml={1}
				display={{
					base: 'none',
					md: 'initial',
				}}
			>
				<Tooltip label={t('Delete interval')}>
					<IconButton
						isDisabled={props.isLoading}
						onClick={props.onDeleteClick}
						size="sm"
						aria-label="Delete"
						icon={<FiTrash />}
					/>
				</Tooltip>
				{props.shouldDisplayRepeat ? (
					<Tooltip label={t('Repeat every weekday')}>
						<IconButton
							isDisabled={props.isLoading}
							onClick={props.onRepeatClick}
							size="sm"
							aria-label={t('Repeat every weekday')}
							icon={<FiCopy />}
						/>
					</Tooltip>
				) : null}
				{props.shouldDisplayAdd ? (
					<Tooltip label={t('Add interval')}>
						<IconButton
							isDisabled={props.isLoading}
							onClick={props.onAddClick}
							size="sm"
							aria-label="Add"
							icon={<FiPlus />}
						/>
					</Tooltip>
				) : null}
			</ButtonGroup>
		</Box>
	);
}
